// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconEdit: React.FC = () => {
    return (
        <svg
            width="12px"
            height="13px"
            viewBox="0 0 12 13"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="currentColor"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    id="Header-+-Footer/Header/Header-:-Tablet/Tablet-:-Header-:-Authenticated"
                    transform="translate(-178.000000, -10.000000)"
                    fill="currentColor"
                    fillRule="nonzero"
                >
                    <g transform="translate(24.000000, 6.000000)">
                        <g transform="translate(154.001099, 4.499941)">
                            <path d="M11.668432,1.73818374 L10.2598381,0.329589844 C9.820385,-0.109863281 9.10694744,-0.109863281 8.66772892,0.329589844 L7.34280707,1.65498018 L10.3217135,4.65498054 L11.6473384,3.32958984 C12.1090574,2.88990211 12.1090574,2.17763686 11.668432,1.73818374 Z M6.81452562,2.18513703 L0.727806585,8.27185607 C0.675447362,8.32421565 0.639799016,8.39087176 0.625244277,8.46348095 L0.00790061241,11.5502 C-0.0461222958,11.8125587 0.185229318,12.0445905 0.447729247,11.9930277 L3.53444793,11.375684 C3.60705747,11.3611736 3.67368998,11.3255045 3.72604956,11.2731922 L9.8127686,5.18647313 L6.81452598,2.18513703 L6.81452562,2.18513703 Z"></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(IconEdit);
